import { create } from "zustand";

/**
 * Standalone trigger for the shared project-details survey sidesheet. Has no
 * knowledge of the enquiry flow (or of any other caller) — whoever opens it
 * passes its own onComplete/onSkip and gets called back, so the survey can
 * be launched from the get-in-touch chain, a future Contractor Listing
 * banner, or anywhere else, independently.
 */
export const useSurveySheetStore = create((set) => ({
  isOpen: false,
  initialAnswers: null,
  onComplete: null,
  onSkip: null,
  // Called by the header's back arrow specifically (distinct from the
  // explicit "Skip" action) — defaults to onSkip when the caller has no
  // meaningful "previous screen" to distinguish it from.
  onBack: null,
  // "enquiryFlow" when opened as a step of the mandatory-form -> review
  // chain (EnquiryFlowShell then hosts it inline, sliding, instead of it
  // popping up as its own separate sheet) — null/omitted for any other,
  // truly standalone caller.
  context: null,

  open: ({ initialAnswers = null, onComplete, onSkip, onBack, context = null } = {}) =>
    set({ isOpen: true, initialAnswers, onComplete, onSkip, onBack: onBack ?? onSkip, context }),

  close: () =>
    set({
      isOpen: false,
      initialAnswers: null,
      onComplete: null,
      onSkip: null,
      onBack: null,
      context: null,
    }),
}));
